/** @prettier */

/**
 * 権限譲渡のメッセージダイアログ
 */

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {PrimaryButton} from '../../component/BasicButton';

/**
 * メッセージダイアログ
 * @param props props
 * @returns JSX
 * - open ダイアログを開く変数
 * - setOpen openのセット関数
 * - message ダイアログに表示する文字
 * - setIsOpenParentDialog 呼び出し元のダイアログのセット関数
 * - id ID
 */
const TransferMessageDialog = (props: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  message: string;
  id?: string;
  setIsOpenParentDialog?: (arg0: boolean) => void;
}) => {
  /**
   * OKボタン押下時処理
   */
  const handleClose = () => {
    if (props.setIsOpenParentDialog !== undefined) {
      props.setIsOpenParentDialog(false);
    }
    props.setOpen(false);
  };

  const trans = useTranslation().t; //翻訳関数

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">
        {trans('TransferMessageDialog.title')}
      </DialogTitle>
      <DialogContent>
        {/* ダイアログに表示するメッセージ */}
        <DialogContentText id="mv-processError-text">
          {props.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          onClick={handleClose}
          buttonText={trans('TransferMessageDialog.buttonTxt.ok')}
          id={props.id}
        />
      </DialogActions>
    </Dialog>
  );
};
export default TransferMessageDialog;
